import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ROUTER_NAME } from '../router'
import Exam from '../models/exam'
import ExamStatusForm from '../../api/v2/forms/answer_status'
import { examTestState } from '../stores/exam_test'
import UserExam from '../models/user_exam'

export function useExam() {
  const router = useRouter()
  const route = useRoute()

  const TYPE_USE_NIGATE_EXAM = Exam.TYPE_USE_NIGATE_EXAM
  const TYPE_USE_SPECIAL_EXAM = Exam.TYPE_USE_SPECIAL_EXAM
  const TYPE_USE_EXAM_FROM_FAILED = Exam.TYPE_USE_EXAM_FROM_FAILED

  const confimDialog = ref(false)

  const startExam = async (item: Exam, userExam?: UserExam) => {
    if (!item.isDone(userExam)) {
      if (!item.isStarted(userExam)) {
        const examStatusForm = new ExamStatusForm()
        examStatusForm.examId = item.id
        examStatusForm.isStartExam = true
        if (userExam) {
          examStatusForm.userExamId = userExam.id
        }
        await examTestState.saveExamStatus({ examStatusForm })
        // Use userExam from state after save (backend creates new one if needed)
        gotoTest(examTestState.exam!, examTestState.exam!.userExam)
      }
    }
  }

  const resultExam = async (item: Exam, userExam: UserExam) => {
    if (item.isTestTimeOver(userExam)) {
      const examStatusForm = new ExamStatusForm()
      examStatusForm.examId = item.id
      examStatusForm.isFinishExam = true
      examStatusForm.userExamId = userExam.id
      await examTestState.saveExamStatus({ examStatusForm })

      gotoResult(item, userExam)
    }
  }

  const continueExam = async (item: Exam, userExam: UserExam) => {
    if (userExam.questions.length && !item.isDone(userExam)) {
      gotoTest(item, userExam)
    }
  }

  const gotoExam = async (item: Exam, userExam?: UserExam) => {
    const run = async () => {
      await router.push({
        name: ROUTER_NAME.EXAM_SHOW,
        params: {
          examId: item.id.toString()
        },
        query: userExam ? {
          user_exam_id: `${userExam.id}`
        } : {}
      })
    }

    if (route.name === ROUTER_NAME.EXAM_SHOW) {
      await run()
      window.location.reload()
    } else {
      await run()
    }
  }

  const gotoDetail = (item: Exam) => {
    router.push({
      name: ROUTER_NAME.EXAM_DETAIL,
      params: {
        examId: item.id.toString()
      }
    })
  }

  const gotoTest = (item: Exam, userExam: UserExam) => {
    router.push({
      name: ROUTER_NAME.QUESTION,
      params: {
        examId: `${item.id}`,
        questionId: `${userExam.questions[0].id}`,
      },
      query: {
        user_exam_id: `${userExam.id}`
      }
    })
  }

  const reTest = async (item: Exam, examType: string = '') => {
    const response = await examTestState.reTest(item, examType)
    const run = async () => {
      await router.push({
        name: ROUTER_NAME.EXAM_SHOW,
        params: {
          examId: `${response.examId}`
        },
        query: {
          user_exam_id: `${response.userExamId}`
        }
      })
    }

    if (route.name === ROUTER_NAME.EXAM_SHOW) {
      await run()
      window.location.reload()
    } else {
      await run()
    }
  }

  const confimClearAllTest = (item: Exam) => {
    confimDialog.value = false
    examTestState.clearAllTest(item).then(() => {
      gotoExam(item)
    })
  }

  const confimClearHistoryTest = (item: UserExam, emit: (event: 'fetchList') => void) => {
    confimDialog.value = false
    examTestState.deleteUserExam(item).then(() => {
      if (route.name === ROUTER_NAME.EXAM_SHOW) {
        window.location.reload()
      } else {
        emit('fetchList')
      }
    })
  }

  const gotoResult = (item: Exam, userExam: UserExam) => {
    router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: `${item.id}`
      },
      query: {
        user_exam_id: `${userExam.id}`
      }
    })
  }

  return {
    TYPE_USE_NIGATE_EXAM,
    TYPE_USE_SPECIAL_EXAM,
    TYPE_USE_EXAM_FROM_FAILED,
    confimDialog,
    startExam,
    resultExam,
    continueExam,
    gotoExam,
    gotoDetail,
    gotoTest,
    reTest,
    confimClearAllTest,
    confimClearHistoryTest,
    gotoResult
  }
}
